import {useQuery} from '@apollo/client';
import gql from 'graphql-tag';
import React, {useState} from 'react';
import {useLocation} from 'react-router';
import Card from './card/Card';
import CardTitle from './card/CardTitle';
import TitleCaption from './card/TitleCaption';
import TitleNumber from './card/TitleNumber';
import CardContent from './card/CardContent';
import CardPaginator from './card/CardPaginator';
import {Feed} from '../../models/Feed';
import InvoiceTable from './unpaidInvoices/InvoiceTable';
import {getNumberParam} from '../../utils/Parameters';

export default function UnpaidInvoices() {
  const QUERY_PARAM = 'overdue_invoices';
  const location = useLocation();
  const activePage = getNumberParam(location.search, QUERY_PARAM, 1);

  const count = 3;
  const [skip, setSkip] = useState((activePage - 1) * count);
  const [total, setTotal] = useState(0);

  const handlePageSwitch = (page: number) => {
    const newSkip = (page - 1) * count;
    setSkip(newSkip);
  };

  const calculatePage = () => Math.floor(skip / count) + 1;

  const {
    data, loading
  } = useQuery<EventInvoiceFeedData, EventInvoiceFeedVars>(query, {
    variables: {
      skip, count,
    },
    onCompleted: (feedData) => {
      setTotal(feedData.invoices.total)
    },
  });

  const initialLoading = () => loading && total === 0;

  if (initialLoading() || total === 0) {
    return <div/>;
  }

  return (
    <>
      {!data && <div/>}
      {data &&
      <Card loading={false}>
        <CardTitle wide={false}>
          <TitleCaption>Unpaid invoices</TitleCaption>
          <TitleNumber value={total}/>
        </CardTitle>
        <CardContent noBorders={true} loading={loading}>
          <InvoiceTable invoices={data.invoices.items} stripePublicKey={data.configuration.publicStripeKey}/>
        </CardContent>
        <CardPaginator total={total} page={calculatePage()}
          className="px-5"
          perPage={data.invoices.count} queryParamName={QUERY_PARAM}
          onNextClick={handlePageSwitch} onPrevClick={handlePageSwitch}/>
      </Card>
      }
    </>);
}

export interface EventInvoice {
  eventId: string
  title: string
  sentDate: string
  amount: string
  daysOverdue: number
  payable: boolean
  clientStripeId?: string
}

export interface Configuration {
  publicStripeKey: string
}

interface EventInvoiceFeedData {
  invoices: Feed<EventInvoice>
  configuration: Configuration
}

interface EventInvoiceFeedVars {
  skip: number
  count: number
}

const query = gql`
  query UnpaidInvoices($skip: Int!, $count: Int!) {
    invoices: unpaidInvoices(skip: $skip, count: $count) {
      total
      count
      skip

      items {
        eventId
        title
        sentDate
        amount
        daysOverdue
        payable
        clientStripeId
      }
    }
    configuration: configuration {
      publicStripeKey
    }
  }
`;
